import { useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { CampaignsList, CampaignsListStore } from 'pages/campaigns/ui/CampaignsList'
import { useCampaignsPageContext } from 'pages/campaigns/context/context'

export const AllCampaigns = () => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new CampaignsListStore(entities), [])
  const { pageLayoutStore } = useCampaignsPageContext()

  useEffect(store.init, [])

  return <CampaignsList store={store} pageLayoutStore={pageLayoutStore} />
}
